<template>
  <div
    class="h-full overflow-hidden"
    v-loading="tableLoading"
    element-loading-background="rgba(0, 0, 0, 0.5)"
  >
    <div class="icon-search__input mt-10px">
      <el-input
        placeholder="巡检点编码或名称"
        v-model="NameOrCode"
        size="small"
        clearable
        @keypress.enter.native="currentChange(1)"
      >
        <i slot="append" class="el-icon-search cursor-pointer" @click="currentChange(1)"></i>
      </el-input>
    </div>
    <el-table
      :data="tableData"
      :height="`calc(100% - 90px)`"
      @row-click="rowClick"
      highlight-current-row
    >
      <el-table-column label="" width="20">
        <template>
          <div class="selected-row"></div>
        </template>
      </el-table-column>
      <el-table-column label="序号" prop="seqNo" width="55px"></el-table-column>
      <el-table-column label="巡检点名称" prop="name" show-overflow-tooltip></el-table-column>
      <el-table-column label="设备数量" prop="tagCount" width="80"></el-table-column>
      <el-table-column label="监控数量" prop="cameraCount" width="80"></el-table-column>
    </el-table>
    <el-pagination
      class="mt-10px flex justify-center"
      background
      @current-change="currentChange"
      @size-change="sizeChange"
      :current-page="initPagination.pageNum"
      :page-size="initPagination.pageSize"
      layout="total, prev, pager, next"
      :total="initPagination.total"
      :pager-count="5"
    >
    </el-pagination>
  </div>
</template>

<script>
import { InspectPointApi } from '@wiz-api/roam-inspect-management'

const inspectPointApi = new InspectPointApi()

export default {
  name: 'inspectPoint',
  props: {
    cloudRender: {
      type: Object,
      default: () => {},
    },
    customProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
  },
  data() {
    return {
      markerIdList: [],
      NameOrCode: '',
      tableData: [],
      tableLoading: false,
      initPagination: {
        pageNum: 1,
        pageSize: 15,
        total: 0,
      },
    }
  },
  methods: {
    currentChange(val) {
      this.initPagination.pageNum = val
      this.getList()
    },
    sizeChange(val) {
      this.initPagination.pageSize = val
      this.initPagination.pageNum = 1
      this.getList()
    },
    async getList() {
      this.tableLoading = true
      const [err, res] = await inspectPointApi.getList({
        nameOrCode: this.NameOrCode,
        status: true,
        skipCount: (this.initPagination.pageNum - 1) * this.initPagination.pageSize,
        maxResultCount: this.initPagination.pageSize,
      })
      if (!err) {
        res.items.forEach((item, index) => {
          item.seqNo =
            (this.initPagination.pageNum - 1) * this.initPagination.pageSize + (index + 1)

          item.pos = [item.xPoint, item.yPoint, item.zPoint]
          item.perspective = JSON.parse(item.perspective || '{}')
        })
        this.tableData = res.items || []
        this.initPagination.total = res.totalCount
        this.destroyPointmarkers()
        this.createPointmarkers()
      }
      this.tableLoading = false
    },
    async createPointmarkers() {
      this.tableData.forEach(async (item) => {
        const option = {
          id: item.id,
          pos: item.pos,
          background: 'sample',
          nodeOffset: [0, 0],
          text: item.name,
          textColor: '#ffffffff',
          hasTriangle: true,
          markPosType: 4,
        }
        const res = await this.cloudRender.Marker.createBySingleLine(option)
        if (res.data?.length) {
          this.markerIdList.push(res.data[0])
        }
      })
    },
    async destroyPointmarkers() {
      await this.cloudRender.Marker.destroyMarker(this.markerIdList)
      this.markerIdList = []
    },
    rowClick(row) {
      const perspective = row.perspective
      if (perspective.eye) {
        this.cloudRender.Camera.moveCamera('CameraParam', perspective, 1)
      }
    },
    // 返回初始视角
    backInitPositon() {
      if (this.customProps?.sceneOptions?.jsonData) {
        const jsonData = JSON.parse(this.customProps.sceneOptions.jsonData)
        const cameraParams = jsonData.cameraParams
          ? JSON.parse(jsonData.cameraParams)
          : { eye: [-1028, 580, 13821], target: [-1028, 579, 85], up: [0, 1, 0] }
        this.cloudRender.Camera.moveCamera('CameraParam', cameraParams)
      }
    },
  },
  async created() {
    this.getList()
  },
  beforeDestroy() {
    this.backInitPositon()
    this.destroyPointmarkers()
  },
}
</script>
